module.exports = __webpack_public_path__ + "img/my girls the cutest.f94628d1.png";